import React from 'react'
import { string, func } from 'prop-types'
import FaClose from 'react-icons/lib/fa/close'
import styles from './Messages.styl'

export default class Warning extends React.Component {

	static displayName = 'Warning'

	static propTypes = {
		message: string,
		close: func
	}

	render() {
		const { message, close } = this.props
		return (
			<div className={ styles.missingInfo }>
				<div className={ styles.close } onClick={ close }><i><FaClose /></i></div>
				<h2>Por favor preenche a informação em falta!</h2>
				<p>{ message }</p>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/client/website/components/Messages/Warning.js